import React from 'react';
import { StyleSheet, ScrollView } from 'react-native';

import { ListItem } from '@rneui/themed';
import { AntDesign } from '@expo/vector-icons';

import FormField from './FormField';
import ItemForm from './ItemForm';

const styles = StyleSheet.create({
    container: {
        width: '100%',
        justifyContent: 'center',
    },
});

interface Props {
    value: any;
    title?: string;
    tableList: Array<{
        type_id: string;
        name: string;
        description: string;
        image: string;
    }>;
    setFieldValue: (item: any) => void;
    disabled: boolean;
}

const ItemListForm: React.FC<Props> = ({
    value,
    title,
    tableList,
    setFieldValue = null,
    disabled = false,
}) => {
    const [expanded, setExpanded] = React.useState(false);

    return (
        <ListItem.Accordion
            content={
                <ListItem.Content>
                    <ListItem.Title>{title}</ListItem.Title>
                </ListItem.Content>
            }
            isExpanded={expanded}
            onPress={() => {
                setExpanded(!expanded);
            }}
            icon={<AntDesign name="up" size={24} color="black" />}
            style={styles.container}
            disabledStyle={{ backgroundColor: 'lightgray' }}
            disabled={disabled}
        >
            <ScrollView>
                {tableList.map((item, key) => (
                    <ItemForm
                        item={item}
                        key={key}
                        setFieldValue={setFieldValue}
                        expanded={expanded}
                        setExpanded={setExpanded}
                    />
                ))}
            </ScrollView>
        </ListItem.Accordion>
    );
};

export default FormField(ItemListForm);
